import React, { useState, FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RealEstateType } from '../../@types/realEstateType'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { useReportViewEvent } from '../../hooks'
import { Progress } from '../../@types/progress'
import { reportTrackingEvent } from '../../tracking/thunks'
import { LocationStepIcon } from '../../components/icons/StepIcons/LocationStepIcon'
import { ReduxState } from '../../store/reducers'
import Location from '../../components/Location/Location'
import './LocationStep.scss'
import { Flow } from '../../@types/config'

export interface LocationStepProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  goToErrorStep: () => unknown
  progress: Progress
  displayBack: boolean
}

export const getHeadlineText = (realEstateType?: RealEstateType): string => {
  switch (realEstateType) {
    case RealEstateType.LAND:
      return 'das Grundstück?'
    case RealEstateType.HOUSE:
      return 'das Haus?'
    case RealEstateType.APARTMENT:
      return 'die Wohnung?'
    case RealEstateType.COMMERCIAL:
      return 'die Immobilie?'
    default:
      return 'die Immobilie?'
  }
}

export const LocationStep: FC<LocationStepProps> = (props: LocationStepProps) => {
  useReportViewEvent({ pageTitle: 'postcode' })
  const {
    config: { theme, flow },
    lead: { realEstateType },
    location: { data: location },
  } = useSelector((state: ReduxState) => state)

  const [isLocationValid, setIsLocationValid] = useState<boolean>(false)

  const dispatch = useDispatch()

  const Headline = () => {
    return (
      <span>
        Wo befindet sich <br className='lap-hide desk-hide' />
        {getHeadlineText(realEstateType)}
      </span>
    )
  }

  const onNextClick = () => {
    dispatch(
      reportTrackingEvent({
        pageTitle: 'postcode',
        label: 'postcode_submit',
        eventName: 'lead_input',
        inputValue: location?.postcode ?? '',
        customDimensions: { ga_cd_lead_engine_input_value: location?.postcode },
        action: flow === Flow.SOLAR ? 'solar-leadengine' : '',
        category: flow === Flow.SOLAR ? 'residential' : '',
        flow: flow === Flow.SOLAR ? 'sle' : '',
      })
    )

    props.goToNextStep()
  }

  return (
    <StepTemplate
      icon={<LocationStepIcon />}
      headline={<Headline />}
      displayNext={true}
      isNextEnabled={isLocationValid}
      goToNextStep={onNextClick}
      goToPreviousStep={props.goToPreviousStep}
      dataTestingButton={'location-next-button'}
      progress={props.progress}
      displayBack={props.displayBack}
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      <Location onValidationChange={setIsLocationValid} onError={props.goToErrorStep} />
    </StepTemplate>
  )
}

export default LocationStep
